import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";
import { assertNoDemoReportMutations } from "./demoReportMutationGuard";

export interface ArchiveRecordsInputDto {
  recordIds: string[];
}

/**
 * Use case: архивация/разархивация записей (сервер сам определяет целевое состояние).
 */
export class ArchiveRecordsUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(input: ArchiveRecordsInputDto): Promise<void> {
    const { recordIds } = input;
    if (!recordIds.length) {
      return;
    }

    const request = {
      change_names: [],
      for_archive: recordIds,
      for_delete: [],
      delete_link: [],
    };
    assertNoDemoReportMutations(request);
    await this.gateway.updateRecords(request);
  }
}
